import React from 'react'
import { Box } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';

function GridTable({ columns, rows, data, ...props }) {
    return (
        <Box
            padding="0px 10px"
            className
            sx={{
                height: data === 'height' ? '75%' : '70%',
                '& .MuiDataGrid-root': {
                    border: 'none',
                    borderBottom: 'none'
                },
                '& .MuiDataGrid-cellContent': {
                    fontFamily: "Mona Sans !important"
                },
                '& .MuiDataGrid-row:nth-of-type(even)': {
                    backgroundColor: '#F1F1F1',
                    borderRadius: '8px',
                },
                "& .MuiDataGrid-cell": {
                    border: "none",
                },
                "&.MuiDataGrid-cell:focus": {
                    outline: "none !important",
                },
                "&.MuiDataGrid-actionsCell": {
                    boxSizing: 'none !important',
                    gridGap: '1px !important'
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                    fontFamily: "Mona Sans",
                    fontWeight: "bold",
                },
                '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#000000',
                    color: 'white',

                    '& .MuiCheckbox-root': {
                        color: 'white',
                        // background: '#FFFFF'
                    }
                },
                '& .MuiDataGrid-sortIcon': {
                    display: 'none',
                },



            }}

        >
            <DataGrid
                disableColumnMenu
                sx={{
                    fontFamily: 'Mona Sans',
                    '& .MuiDataGrid-iconSeparator': {
                        display: 'none !important',
                    },
                    '& .MuiDataGrid-cellContent': {
                        fontFamily: "Mona Sans !important"
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                        fontFamily: "Mona Sans",
                        fontWeight: "bold",
                    },
                    "&.MuiDataGrid-cell--actions": {
                        boxSizing: 'none !important',
                        display: 'flex',
                        gridGap: '1 !important'
                    },
                    "&.MuiDataGrid-cell:focus": {
                        outline: "none !important",
                    },
                    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
                        width: '0.4em',
                    },
                    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
                        background: '#f1f1f1',
                    },
                    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
                        backgroundColor: '#6A3BE2',
                    },
                    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover': {
                        background: '#555',
                    }

                }}
                {...props}
                rows={rows}
                columns={columns}
                rowHeight={25}
                headerHeight={25}
                hideFooter={true}
                disableColumnSelector

            />
        </Box>
    )
}
export default GridTable;
